var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Pagination from '@web/components/layout/Pagination/Pagination';
import Table from '@web/components/layout/Table/Table';
var PaginatedTable = function (_a) {
    var _b, _c;
    var total = _a.total, typeResultText = _a.typeResultText, pageSize = _a.pageSize, tableProps = __rest(_a, ["total", "typeResultText", "pageSize"]);
    return (_jsxs("div", __assign({ className: "relative" }, { children: [_jsx(Table, __assign({}, tableProps)), _jsx("div", { children: _jsx(Pagination, __assign({}, {
                    pageSize: pageSize,
                    total: total
                }, { displayElements: (_c = (_b = tableProps.data) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0, typeResultText: typeResultText })) })] })));
};
export default PaginatedTable;
